var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuffuIconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0176 24.5962V23.4492C57.0176 23.8315 57.0176 24.2139 57.0176 24.5962ZM40.1969 34.2817V34.5366C39.9421 36.1933 39.3049 37.4677 38.6678 38.2323C38.1581 38.8696 37.1386 39.3793 35.7369 39.7616C34.2077 40.2714 31.2769 41.036 26.1797 40.7812C21.8471 40.5263 22.102 40.6537 21.0825 40.2714C19.8082 39.7616 19.4259 38.8696 18.7888 38.2323C18.0242 37.4677 17.5145 36.1933 17.2596 34.5366C17.2596 34.4091 17.2596 34.4091 17.2596 34.2817L16.4951 24.5962H0.311523C0.311523 29.6938 0.693811 34.1542 1.33096 37.7226C2.09553 41.6733 3.49726 44.7318 5.53613 47.1532C7.575 49.5746 10.5059 51.2313 14.2013 52.3783C17.8968 53.3978 22.7391 53.9076 28.6009 53.9076C34.4626 53.9076 39.3049 53.3978 43.0004 52.3783C46.6958 51.3587 49.6267 49.5746 51.6656 47.1532C53.7044 44.7318 55.1062 41.5458 55.8707 37.7226C56.5079 34.1542 56.8902 29.6938 57.0176 24.5962H41.0889L40.1969 34.2817ZM0.311523 24.5962C0.311523 24.2139 0.311523 23.8315 0.311523 23.4492V24.5962Z",
    fill: "#FE531F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99611 17.8417C14.9225 17.8417 18.9162 13.8477 18.9162 8.92085C18.9162 3.994 14.9225 0 9.99611 0C5.0697 0 1.07605 3.994 1.07605 8.92085C1.07605 13.8477 5.0697 17.8417 9.99611 17.8417Z",
    fill: "#FE531F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4217 17.8417C50.3481 17.8417 54.3418 13.8477 54.3418 8.92085C54.3418 3.994 50.3481 0 45.4217 0C40.4953 0 36.5016 3.994 36.5016 8.92085C36.5016 13.8477 40.4953 17.8417 45.4217 17.8417Z",
    fill: "#FE531F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuffuIconsvg);
export default __webpack_public_path__ + "static/media/puffuIconsvg.df71e89c6a64a0e4baf22aaa779cb9c9.svg";
export { ForwardRef as ReactComponent };